module.exports = __webpack_public_path__ + "img/1.35ae1bd8.svg";